
import Vue from 'vue'

export default Vue.extend({
  name: 'ResetPasswordDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    email: {
      type: String
    }
  }
})
